import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Youtube } from "lucide-react";
import AppyLogo from "./AppyLogo";

export default function Footer() {
  return (
    <footer className="bg-[#0E2E24] text-[#FAFAF8] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center">
              <AppyLogo size={56} className="brightness-0 invert" />
            </div>
            <p className="mt-6 max-w-md text-[#FAFAF8]/75 leading-relaxed">
              Curated farmhouses. Managed end-to-end. Built for celebrations and property owners who want more than a listing.
            </p>

            <div className="mt-8 space-y-3 font-sora text-sm">
              <a href="tel:+914048252525" className="flex items-center gap-3 hover:text-[#F4A930] transition-colors" data-testid="footer-phone">
                <Phone size={16} /> +91 40 4825 2525
              </a>
              <a href="mailto:hello@appystays.com" className="flex items-center gap-3 hover:text-[#F4A930] transition-colors" data-testid="footer-email">
                <Mail size={16} /> hello@appystays.com
              </a>
              <div className="flex items-center gap-3 text-[#FAFAF8]/75">
                <MapPin size={16} /> Jubilee Hills, Hyderabad
              </div>
            </div>

            <div className="mt-8 flex items-center gap-3">
              <a href="#" aria-label="Instagram" className="h-10 w-10 rounded-full border border-[#FAFAF8]/20 flex items-center justify-center hover:border-[#F4A930] hover:text-[#F4A930] transition-colors" data-testid="footer-instagram"><Instagram size={16} /></a>
              <a href="#" aria-label="YouTube" className="h-10 w-10 rounded-full border border-[#FAFAF8]/20 flex items-center justify-center hover:border-[#F4A930] hover:text-[#F4A930] transition-colors" data-testid="footer-youtube"><Youtube size={16} /></a>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-8">
            <FooterCol title="Explore" links={[["Stays", "/stays"], ["Managed", "/stays?managed=true"], ["Events", "/events"]]} />
            <FooterCol title="Brand" links={[["About", "/about"], ["Partner", "/partner"], ["Contact", "/about#contact"]]} />
            <FooterCol title="Occasions" links={[["Weddings", "/stays?occasion=Weddings"], ["Birthdays", "/stays?occasion=Birthdays"], ["Corporate", "/stays?occasion=Corporate%20Outings"]]} />
            <FooterCol title="Legal" links={[["Terms", "#"], ["Privacy", "#"], ["House Rules", "#"]]} />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FAFAF8]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[#FAFAF8]/60 font-sora text-sm">
          <span>© {new Date().getFullYear()} Appy Stays — Made in Hyderabad.</span>
          <span className="text-[#F4A930]">Celebrate Better. Stay Better.</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="kicker text-[#F4A930] mb-4">{title}</div>
      <ul className="space-y-3 font-sora text-sm">
        {links.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-[#FAFAF8]/80 hover:text-[#F4A930] transition-colors">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
